const en = {
  general: {
    position: 'Position',
    updateSuccess: 'Update successful!',
    editProfileImg: 'Edit Profile Picture',
    editCoverImg: 'Edit Cover Picture',
    register: 'Sign Up',
    login: 'Log In',
    date: 'Date',
    export: 'Export',
    or: 'or',
    end: 'End',
    confirmEmail: 'Confirm Email',
    password: 'Password',
    forgetPassword: 'Forgot password?',
    changePassword: 'Change password',
    confirmPassword: 'Confirm Password',
    knownAs: 'Known as',
    oldPassword: 'Old password',
    newPassword: 'New password',
    minLength: 'Minimum length is {n}',
    unmatched: '{col} does not match.',
    chooseAnotherAccount: 'Log in with another account',
    confirmNewPassword: 'Confirm new password',
    required: 'Field required.',
    country: 'Country',
    new: 'NEW',
    username: 'User Name',
    category: 'Category'
  },
  editPhoto: 'Edit Photo',
  deletePhoto: 'Delete Photo',
  changePhoto: 'Change Photo',
  savePhoto: 'Save Photo',
  livetour: 'Showroom',
  country: {
    JP: 'Japan',
    KR: 'Korea',
    HK: 'Hong Kong and Macau',
    SG: 'Singapore',
    MY: 'Malaysia',
    TH: 'Thailand',
    VN: 'Vietnam',
    ID: 'Indonesia',
    PH: 'Philippines',
    EU: 'Europe',
    NA: 'North America',
    NZ: 'New Zealand and Australia',
    TW: 'Taiwan'
  },
  vrlounge: {
    ticketNotOnboardHint: 'Please enter the online virtual exhibition after onboarding the ticket at the physical exhibition.',
    cannotChangeAfterSubmit: 'Cannot change after submit',
    hintLogin: 'If you’ve registered with your ticket number, please click “Log In” to log in by your email.',
    lounge: 'VR Lounge',
    networking: 'Networking',
    profile: 'My Profile',
    peopleOnline: 'People Online',
    totalVisitors: 'Total Visitors',
    connect: 'Connect',
    waitConfirmed: 'Wait to be confirmed',
    isConfirmed: 'CONFIRMED',
    confirm: 'CONFIRM',
    reject: 'REJECT',
    confirmReject: 'Are you sure you would like to reject?',
    hintReject: 'This cannot be canceled',
    thinkTwice: 'Let me think twice',
    rejectInvitation: 'Reject invitation',
    connectSuccess: 'Connect Success!',
    block: 'Block',
    visitor: 'Visitor',
    exhibitor: 'Exhibitor',
    invitationTitle: 'Personalized Invitation Message',
    invitationPlaceholder: 'Hello! Hope to connect with you! (at most 1000 characters)',
    noTicketRecord: 'No ticket record. Please purchase a ticket.',
    invalidTicket: 'Invalid ticket',
    enterTicket: 'Please enter your ticket number',
    sent: 'Sent',
    received: 'Received',
    connected: 'Connected',
    agreeToContinue: 'You must agree to the Terms & Conditions and Privacy Policy to continue.',
    ticketUsed: 'This ticket has been used.',
    passwordRule: 'The password must contain 8 characters, at least one letter and one number.',
    cardExchange: 'The visitor wants to exchange business cards with you, please confirm whether to accept or reject the exchange.',
    loginToAccount: 'Log in to your account',
    keepLogin: 'Keep me logged in',
    cantLogin: 'Can’t log in? Click ',
    here: 'here',
    allRole: 'All role',
    sortNameAtoZ: 'Name (A→Z)',
    sortNameZtoA: 'Name (Z→A)',
    onlineNewToOld: 'Last Login Time (Latest)',
    onlineOldToNew: 'Last Login Time (Earliest)',
    exhibitorFirst: 'Exhibitor First',
    visitorFirst: 'Visitor First',
    inviteTimeNewToOld: 'Invite Time (Latest)',
    inviteTimeOldToNew: 'Invite Time (Earliest)',
    basicInfo: 'Basic Info',
    contact: 'Contact',
    contactInfo: 'Contact information',
    state: 'State',
    sentRequest: 'Send Request',
    haveNotConfirmed: 'You haven’t confirmed yet',
    message: 'Message',
    sendMessageTo: 'Message'
  },
  sort: 'Sort',
  filter: 'Filter',
  test: 'Test',
  apply: 'Apply',
  all: 'All',
  livingroom: 'Living room',
  diningroom: 'Dining room',
  kitchen: 'Kitchen',
  bedroom: 'Bedroom',
  study: 'Study',
  bathroom: 'Bathroom',
  toilet: 'Toilet',
  garden: 'Garden',
  garage: 'Garage',
  outdoors: 'Outdoors',
  others: 'Others',
  vrTooltip: 'VR mode is only available for mobile devices',
  vrInstructions: 'Please put the <strong>phone</strong> in a <strong>VR headset</strong>.',
  send: 'Send',
  scanQrCode: 'Scan QR code to view the virtual tour on your phone.',
  logOut: 'Log out',
  postAsAnonymous: 'No thanks, I\'ll post as anonymous.',
  loginGoogle: 'Log in with Google+',
  loginFacebook: 'Log in with Facebook',
  postComment: 'Leave a comment',
  selectAction: 'Please select',
  noBuilding: 'Sorry, this LiveTour doesn\'t exist.',
  browserNoSupport: '<h3>Sorry, your browser is not supported.</h3><p>Please download and install another browser like<a href="https://www.google.com/chrome/browser/desktop">Chrome</a>,<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a>, or<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>.</p>',
  webGlNoSupport: '<h3>Failed to get WebGL context. Your browser or device may not support WebGL.</h3>',
  urlNoSupportIFrameError: 'This link has expired or the page does not accept external embedded links.',
  noPanoramas: 'Oops！The panorama does not exist.',
  buildingNotFound: '<h3>Oops! The link does not exist. </h3><p> The LiveTour cannot be found.</p><a href="https://www.istaging.com/en/livetour-gallery">See other LiveTours</a>',
  buildingNotInPropertyRedirect: '<h3>Oops! The LiveTour has been removed.</h3><p>Redirecting you to the first LiveTour of the list......</p>.',
  information: 'Information',
  panoSelect: 'Panoramas',
  floorplan: 'Floor Plan',
  qrCode: 'QR Code',
  music: 'Music',
  openMusic: 'Turn on background music',
  closeMusic: 'turn off background music',
  gyro: 'Gyro',
  vrmode: 'VR mode',
  fullscreen: 'Fullscreen',
  like: 'Like',
  comment: 'Comment',
  propertyInfo: 'Group info',
  buildingInfo: 'LiveTour info',
  buyNow: 'Buy now',
  viewAtHome: 'View in AR',
  learnMore: 'Learn more',
  contactSupplier: 'Contact supplier',
  memo: 'Memo',
  location: 'Location',
  promotionText: 'Virtual Tours Made Easy >',
  promotionLinkText: 'Get Started from $5',
  close: 'Close',
  addComment: 'Add comment',
  share: 'Share',
  leaveInfoContinue: 'Please enter your information to view this LiveTour',
  company: 'Company',
  companyName: 'Company Name',
  name: 'Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phone: 'Phone',
  occupation: 'Occupation',
  emailFormatInvalid: 'Invalid email format.',
  duplicateEmail: 'Duplicate email',
  privacyPolicy: 'Privacy Policy',
  userTerms: 'Terms & Conditions',
  visitorLogin: 'Have an account?',
  visitorAgreement1: 'Your privacy is important to us. By submitting your information, you agree to {company}’s {privacyTag} and {termsTag}.',
  visitorAgreement2: 'You authorize {company} to call, email, text or mail you information about {company}’s products and services. You may withdraw this authorization by contacting us at {email}.',
  visitorAgreement: 'I agree to the <a href="https://www.istaging.com/en/terms" target="_blank">Terms of Use </a> & <a href="https://www.istaging.com/en/privacy" target="_blank">Privacy Policy</a>.',
  visitorLeaveDataReason: 'Welcome to this virtual experience! Once you submit your contact information, you will receive a verification link via email, so you can enter.',
  visitorAgreePolicy: 'I agree that the owner of this virtual experience may contact me via email or phone.',
  visitorCheckTheEmail: 'Almost there!<br>Let\'s confirm your email address. Go to your inbox and verify your email by clicking on the link you have received.<br>You are one step away from accessing the virtual experience!',
  visitorEnterAccessKey: 'Please enter the access code you received by email. If you haven\'t received it, check your spam folder.',
  accessCode: 'access code',
  accessCodeError: 'access code error',
  receiveEmailVerification: 'Please get your access code in your email.',
  verify: 'Verify',
  back: 'Back',
  welcomeToLiveTour: 'Welcome to the <strong>LiveTour</strong>',
  resend: 'Resend',
  invalidAccessCode: 'Access code is invalid',
  resendCodeError: 'Failed to resend access code',
  website: 'Website',
  cardMore: 'More',
  clickNavigate: 'Navigate',
  showMore: 'Show More',
  searchTag: 'Search Tag',
  somethingWrong: '<h3>oops....something went wrong....</h3><a href="https://www.istaging.com/en/contact">report this unknown problem</a>',
  GuidedTour: 'Guided Tour',
  ClientWelcome: 'Welcome',
  ClientFormHint: 'By clicking "Call now", I agree to the <a href="https://www.istaging.com/en/terms" target="_blank" class="link-yellow">Terms of Service,</a> <a class="link-yellow" href="https://www.istaging.com/en/privacy" target="_blank">Privacy Policy</a> and the agent can contact me by phone',
  ClientFormWelcomeText: 'Fill in the following information and click "Call now".<br>You will be guided online by an agent.<br>Connect your headset and microphone and make sure you have a good network connection for a better experience.',
  ClientWelcomeNamePhoneHint: 'Please enter your name and phone number',
  ClientWelcomeNameHint: 'Please enter your name',
  ClientWelcomePhoneHint: 'Please enter the phone number or the format is incorrect',
  ClientWelcomeLanguage: 'Language',
  ClientWelcomeLanguageDesc: 'Please select the Tour Guide language.',
  ClientWelcomeLanguageHint: 'Please select a language',
  FieldRequired: '* required',
  ClientFormCallNow: 'Call now',
  None: 'N/A',
  Agent: 'Agent',
  RememberMe: 'Remember me',
  TheFieldIsRequired: '*required field',
  IncorrectFormat: 'Wrong format',
  YouMustAgreeLicense: 'You need to agree with the above mentioned terms.',
  Submit: 'Submit',
  BuildingNonPublicInfo: 'This LiveTour is hidden from view.',
  WebRTCNotSupportTitle: 'Browser does not support',
  WebRTCNotSupportDesc: 'Copy the page URL and paste to Google Chrome, Firefox or Safari',
  WebRTCNotSupportDesciOS: 'Copy the page URL and paste to Safari',
  WebRTCNotSupportDescAndroid: 'Copy the page URL and paste to Chrome or Firefox',
  WebRTCNotSupportCopyButton: 'One-click copy',
  Copied: 'Copy completed',
  search: 'Search',
  searchContent: 'Search content',
  noResult: 'No results found',
  searchResult: 'Search Result',
  relatedResult: 'Related Result',
  scaleUp: 'Scale up',
  scaleDown: 'Scale down',
  viewIn3D: 'View in 3D',
  unableJoinMeeting: 'Unable to Join Meeting',
  invalidMeetingId: 'Invalid meeting ID',
  unableAccessMediaDevice: 'Your browser is preventing access to your camera / microphone, please check browser media permission settings.',
  connectingMeeting: 'You\'re going to host a meeting',
  meetingNotStartedYet: 'Unable to join the meeting. It has not started yet. Please click to wait for the host',
  joinedMeeting: 'You\'re in the meeting',
  joiningMeeting: 'You\'re going to join a meeting',
  repeatJoinWarning: 'If you join again, the originally connected page will be disconnected.',
  meetingIsOver: 'Meeting is over.',
  startAnotherMeeting: 'Please go to the editor to start another meeting.',
  closeMeeting: 'Close',
  joinMeeting: 'Join Meeting',
  leaveMeeting: 'Leave',
  remainTime: 'Remaining Time',
  meetingIsFull: 'Your meeting is full',
  connectionFail: 'Connection failed',
  unableConnectMeeting: 'Unable to Join Meeting',
  joinMeetingFail: 'Failed to join meeting',
  aboutEndMeeting: 'You are about to end this meeting',
  aboutLeaveMeeting: 'You are about to leave this meeting',
  endedMeeting: 'This meeting has ended',
  meetingRedirect: 'We are directing you to the LiveTour.',
  leftMeeting: 'You have left this meeting',
  waitMeeting: 'The host has left temporarily. The meeting will continue after the host connects. If the host is not connected within 5 minutes, the meeting will end',
  disconnectMeeting: 'You are disconnected. Please try to reconnect within 5 minutes and refresh the page to return to the meeting.',
  copyLink: 'Copy Link',
  copySuccess: 'Copied successfully',
  confirm: 'OK',
  cancel: 'Cancel',
  IMServe: 'Instant customer service',
  product: 'Product',
  pilot: 'Pilot',
  pilotBooking: 'Book a tour',
  pilotStop: 'Stop piloting',
  pilotTours: 'Tours',
  pilotPopularTours: 'Popular tours',
  pilotInfluencerList: 'Tour guide list',
  pilotTourBy: 'Tour by {influencer}',
  PilotDescription: 'Description',
  PilotDetailedInformation: 'Detailed Information',
  pilotSwitchTourNotice: 'You are now playing "{pilot1}".<br>Are you sure you want to start "{pilot2}"?',
  pilotSameTourNotice: 'You are now playing "{pilot1}".<br>Do you want to start from the beginning?',
  pilotPlayerPopupButtonYes: 'Yes',
  pilotRecorderStart: 'Click here to start',
  pilotRecorderStop: 'Click here to stop',
  pilotRecorderUploading: 'Uploading...',
  pilotRecorderUploadFailed: 'Upload failed',
  pilotRecorderPopupTitleNotice: 'Notice',
  pilotRecorderPopupTitleComplete: 'Record Complete',
  pilotRecorderPopupTitleError: 'Error',
  pilotRecorderPopupTextNotice: '• The recording time is limited to 10 minutes.<br>• Please allow the system to access your microphone.',
  pilotRecorderPopupTextComplete: 'Your chapter is completed.<br>Please review in the VR Editor.',
  pilotRecorderPopupTextRelogin: 'Re-login required.',
  pilotRecorderPopupTextError: 'Please check the microphone permission in your browser.',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: 'The 10-minute recording time will end soon. Please complete your recording.',
  pilotTooltipTitle: 'Reminder, you can click here to see more guided routes.',
  pilotTooltipConfirm: 'I see! let\'s start',
  pilotTooltipCancel: 'Skip the tour',
  selectPilot: 'Select pilot',
  pilotInfluencer: 'Pilot influencer',
  pilotChaptersTitle: 'Route chapters (choose to listen)',
  pilotReadMoreBtnLabel: 'View full content',
  pilotSelfBrowsingModeMessageTitle: 'Enter self-browsing mode',
  pilotSelfBrowsingModeMessageContent: 'You can return to tour mode at any time by clicking the turn-on button.',
  pilotReplay: 'Replay',
  pilotPrevious: 'Previous',
  pilotNext: 'Next',
  pilotPause: 'Pause',
  pilotPlay: 'Play',
  pilotTurnOnSelfBrowsingMode: 'Turn off tour mode',
  pilotTurnOffSelfBrowsingMode: 'Turn on tour mode',
  conferenceDisconnect: 'Poor internet connection. Please check your connection.',
  conferenceMute: 'Mute',
  conferenceUnmute: 'Unmute',
  conferenceStopVideo: 'Stop Video',
  conferenceVideo: 'Video',
  conferenceShare: 'Share',
  conferenceChat: 'Chat',
  conferenceParticipant: 'Participants',
  conferenceAudience: 'Audience',
  conferenceMore: 'More',
  conferenceCopyLink: 'Copy Meeting Link',
  conferenceCameraAndMicrophone: 'Camera and microphone',
  conferenceHost: 'Host',
  conferencePresenter: 'Presenter',
  conferenceExpel: 'Delete',
  conferenceChangeRole: 'Change role to',
  conferenceTypeMessage: 'Type your message here',
  conferenceEveryone: 'Everyone',
  conferenceLoginError: 'There was an error logging in to the channel, please try again',
  conferenceJoinError: 'An error occurred while entering the channel, please try again',
  conferenceLeaveError: 'An error occurred while leaving the channel, please try again',
  conferenceGetMemberCountError: 'An error occurred while obtaining the number of channel members, please try again',
  conferenceSendMessageError: 'There was an error while sending the message, please try again',
  conferenceSendInfoError: 'An error occurred while posting the news, please try again',
  conferenceGetMemberError: 'There was an error getting channel members, please try again',
  conferenceChangeRoleError: 'An error occurred while setting the role, please try again',
  conferencePublishError: 'An error occurred while publishing the video, please try again',
  conferenceCancelPublishError: 'An error occurred while unpublishing the video, please try again',
  conferenceGetMemberInfoError: 'An error occurred while getting member information, please try again',
  conferenceSetMediatError: 'An error occurred while adjusting the video, please try again',
  conferenceToLeave: 'Do you want to leave the meeting',
  conferenceToExpel: 'Do you want to remove %{name} from this meeting',
  conferenceChangeRoleFail: 'Role change failed',
  conferenceGetChangeRole: 'You are now %{role} of this meeting',
  conferenceGetCameraClosed: 'Video Stopped by Host',
  conferenceGetUnmuted: 'Audio Unmuted by Host',
  conferenceGetMuted: 'Audio Muted by Host',
  conferenceCopyLinkSuccess: 'Meeting link is copied',
  conferenceGetExpeled: 'The host has removed you from the meeting.',
  conferenceBrowserNotSupported: 'Your browser is not supported. Upgrade to the latest version of Chrome, Safari or Edge.',
  conferenceNotStart: 'The meeting has not started yet',
  conferenceEnd: 'The meeting has finished',
  conferenceTimeup: 'The meeting time is up',
  conferenceMicrophone: 'Microphone',
  conferenceSoundLevel: 'Sound Level',
  conferenceVolume: 'Sound Volume',
  conferenceCamera: 'Camera',
  conferenceDetectAudioFail: 'Unable to detect sound device',
  conferenceDetectVideoFail: 'Unable to detect video device',
  conferenceShareNotAvailable: 'This browser does not support sharing. To share content, use the latest version of Chrome, Edge or Firefox.',
  conferenceScreenNotAvailable: 'Other presenters are sharing the screen',
  uploadImage: 'Upload Image',
  booking: {
    calendar: 'Calendar',
    reserve: 'Reserve',
    dateSelectTitle: 'Choose a time that works for you.',
    backToSelect: 'Choose a different time',
    requiredField: 'This is a required field',
    timeRange: 'Time range',
    fieldMessage: 'Message',
    confirm: 'Confirm Booking',
    pleaseWait: 'Please wait...',
    submitError: 'An error occurred while sending the request: ',
    reserveSuccess: 'Booking Successful',
    thanksUser: 'Thanks,',
    confirmingEmail: 'You\'ll receive a notification confirming the meeting details shortly.',
    emailEmptyHint: 'Email is empty.'
  },
  favorites: {
    title: 'Favorites',
    add: 'Add to favorites',
    remove: 'Remove from favorites',
    category: {
      marker: 'Product',
      panorama: 'Showroom',
      company: 'Company',
      card: 'Business card'
    },
    table: {
      image: {
        company: 'Logo',
        marker: 'Product image',
        card: 'Avatar'
      },
      name: {
        company: 'Company name',
        marker: 'Product name',
        card: 'Name'
      },
      description: {
        company: 'Company description',
        marker: 'Product description'
      },
      type: 'Type',
      // price: 'Price',
      note: 'Note',
      company: 'Company',
      occupation: 'Occupation',
      listEmpty: 'Nothing yet'
    },
    note: {
      empty: 'Enter a note...(Up to {n} letters)',
      saved: 'Saved!'
    },
    pdf: {
      export: 'Export as PDF',
      exporting: 'Exporting...',
      note: 'Note: ',
      pager: 'Page {page} of {total}'
    }
  },
  video360: {
    notAvailable: 'The video is not available in your country.'
  },
  utils: {
    more: 'Show More',
    less: 'Show Less'
  },
  introAssets: {
    enter: 'Enter'
  },
  Authorize: 'Authorize',
  AuthorizeRequired: 'Authorization required',
  AuthorizeInMicrosoft: 'Authorize this app in Microsoft',
  agreeNonDisclosureAgreement: 'By clicking "Authorize", I agree to the <span ref="ndaLink" class="link-nda">NON DISCLOSURE AGREEMENT</span>',
  clickAuthorizeToAgree: 'By clicking "Authorize", I agree to the',
  nonDisclosureAgreement: 'NON DISCLOSURE AGREEMENT',
  AuthorizeAccept: 'Accept',
  accessLiveTourSteps: '3 STEPS TO ACCESS TOUR LIVETOUR',
  NDA: 'Non-disclosure Agreement',
  productUnavailable: 'This item is no longer available',
  whiteList: {
    login: 'Sign In to Explore!',
    error: '* Invalid account or password! Please try again.',
    warnTitle: 'Authentication Failed',
    warnContent: 'Your username does not exist in the authorized list, please try again or contact the administrator.'
  },
  instantMessaging: {
    quickQA: 'Quick Q&A',
    mediaMessage: 'Shared a file',
    locationMessage: 'Shared a file',
    startConversation: 'Start a conversation with the organizer in this exhibition area!'
  },
  noSearchResult: 'No data is found, please change the query conditions and search again',
  tourring: {
    host: 'Host',
    noAnswer: 'Your contact is currently unable to answer.',
    noPushId: 'Your contact is currently unavailable.',
    busy: 'Your contact is busy with a guided tour.',
    response: 'Please refer to the reservation calendar.',
    goToReserve: 'Access to the calendar',
    dialing: 'Dialing',
    dialingHint: 'After you\'re connected, it will open a new tab',
    handupPhoneHint: 'Your call is not connected yet,',
    handupPhoneHint2: 'Please confirm whether or not to hang up.'
  },
  otherFunctions: 'Other functions',
  returnToFirstPanorama: 'Return To First Panorama',
  cookieBannerContent: 'We use cookies to enhance your browsing experience, serve personalized ads or content. By forwarding of viewing the website, you consent to our use of cookies. Please check',
  cookieBannerContentLinkAfter: 'for detail.',
  cookieBannerPolicyLinkText: 'iStaging Privacy Statement',
  cookieBannerButtonText: 'Accept'
}

export default en
